import { CatalogSection } from './CatalogSection';

export const MaterialsSection = ({ filterKey }: { filterKey?: string }) => (
  <CatalogSection kind="MATERIAL" filterKey={filterKey} />
);
